// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QLNF","option":"styles_option__14FVG","active":"styles_active__3oof7"};